import React from 'react';
import { ILS } from '../../utils/salesUtils';

const CASHBACK_RATE = 0.01;

export default function TotalsCard({ subtotal, discountAmount, discount, total, earnCashback = true }) {
  const cashbackEarned = (total * CASHBACK_RATE).toFixed(2);

  return (
    <div className="pos-totals">
      <div className="pos-totals-row">
        <span className="pos-totals-k">Subtotal</span>
        <span className="pos-totals-v">{ILS(subtotal)}</span>
      </div>
      {discount && discountAmount > 0 && (
        <div className="pos-totals-row">
          <span className="pos-totals-k">
            {discount.type === 'membership'
              ? '🏅 Membresía'
              : discount.type === 'bath-package'
              ? '🛁 Paquete de baños'
              : `Descuento${discount.type === 'percent' ? ` · ${discount.value}%` : ''}`}
          </span>
          <span className="pos-totals-v neg">−{ILS(discountAmount)}</span>
        </div>
      )}
      <div className="pos-totals-row grand">
        <span className="pos-totals-k">Total a pagar</span>
        <span className="pos-totals-v">{ILS(total)}</span>
      </div>
      {total > 0 && earnCashback && (
        <div className="pos-totals-cashback">
          <span>🎉 Cashback ganado · 1%</span>
          <span>+$ {cashbackEarned}</span>
        </div>
      )}
    </div>
  );
}
